import { ButtonRounded, EditableVideo, WContainer, WImage } from '@components/atoms'
import Play from '@components/icons/Play'
import { CollezioneItemType } from '@utils/types'
import { useState } from 'react'
import styles from './AreaEditoriale.module.sass'
import TextMedia from '../TextMedia/TextMedia'
import useTrans from '@hooks/useTrans'

interface Props {
  collezione: any
  className?: string
}

const AreaEditoriale = (props: Props) => {
  const { collezione = undefined, className = '' } = props

  const t = useTrans()

  return collezione?.claim || collezione?.abaco?.url ? (
    <div className={`${styles.root} ${className}`}>
      <WContainer variant="sm">
        <div className={styles.layout}>
          {!!collezione.claim && (
            <h2 className={styles.title} dangerouslySetInnerHTML={{ __html: collezione.claim }} />
          )}
          {!!collezione.abaco?.url && (
            <div className={styles.imageBox}>
              <WImage
                className={styles.image}
                src={collezione.abaco.url}
                //alt={collezione.abaco.imageAlt}
                maxHeight={622}
                maxWidth={1028}
              />
            </div>
          )}
        </div>
      </WContainer>
    </div>
  ) : (
    <></>
  )
}

export default AreaEditoriale
